import { createClient } from '@supabase/supabase-js';

// Ted's Supabase credentials
const supabaseUrl = 'https://vklmmvodwhrgttvbczyy.supabase.co';
const supabaseAnonKey = 'sb_publishable_asrk0DKD10XRQJ8JzO549A_wW_tpVhd';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
